// @ts-nocheck
import { MOCK } from "@/state/app-store";
import { UI } from "@/components/ui";
import { Icon } from "@/components/icons";
import { api } from "@/api/index";

const { $, $$, fmtNum, fmtMoney, fmtPercent, toast, confirmModal, hasPerm, statusBadge, trendArrow, statCard, channelChip, capabilityBadge, pageHeader, emptyState, primaryBtn, ghostBtn, stepIndicator, BUSINESS_COLORS, chartTooltip, chartXAxis, chartYAxis, chartLineSeries, chartBarSeries } = UI;

declare const echarts: any;
declare const Pages: Record<string, any>;
declare const PageHooks: { mounted?: ((path: string) => void) | null };
declare function navigate(path: string): void;
declare function getCurrentPath(): string;
declare function getCurrentPathWithQuery(): string;
declare function renderRoute(): void;

if (typeof window !== "undefined") {
  (window as any).Pages = (window as any).Pages || {};
}

const Pages = (window as any).Pages;

// ============================================================
// SDK 监控（研发工具 / SDK 监控）· 新视觉版
// ============================================================

window.Pages = window.Pages || {};

Pages.sdkMonitor = function () {
  const m = MOCK.SDK_MONITOR;

  PageHooks.mounted = () => {
    const el = document.getElementById("sdk-call-trend");
    if (el) {
      const c = echarts.init(el);
      c.setOption({
        grid: { top: 40, right: 24, bottom: 36, left: 56 },
        tooltip: UI.chartTooltip(),
        legend: { data: ["share()", "trackEvent()", "fetchConfig()"], top: 0, itemWidth: 10, itemHeight: 10, icon: "circle", textStyle: { color: "#6B7280", fontSize: 12 } },
        xAxis: UI.chartXAxis(MOCK.TREND_DATA.dates),
        yAxis: UI.chartYAxis(),
        series: [
          UI.chartLineSeries("share()", MOCK.TREND_DATA.share.map(v => v * 10), { color: "#7C3AED", area: true }),
          UI.chartLineSeries("trackEvent()", MOCK.TREND_DATA.share.map(v => v * 65), { color: "#10B981", area: false }),
          UI.chartLineSeries("fetchConfig()", MOCK.TREND_DATA.share.map(v => Math.floor(v * 1.8)), { color: "#F59E0B", area: false }),
        ],
      });
      window.addEventListener("resize", () => c.resize());
    }

    // 实时事件流
    const stream = document.getElementById("event-stream");
    if (!stream) return;
    let counter = 0;
    const events = [
      { ev: "share()", channel: "Facebook", user: "user_a_3219", refCode: "ref_a9f3ce2b8d", configID: "cfg_pkg_001", cardID: "card_pkg_001", landingID: "lp_001_new", color: "brand", status: "✓" },
      { ev: "selectCombo()", channel: "—", refCode: "cfg_pkg_001/card_pkg_001", configID: "cfg_pkg_001", cardID: "card_plan_001", landingID: "lp_001_return", color: "amber", status: "✓" },
      { ev: "trackEvent.click", channel: "Facebook", refCode: "ref_a9f3ce2b8d", configID: "cfg_pkg_001", cardID: "card_pkg_001", landingID: "lp_001_new", color: "blue", status: "✓" },
      { ev: "trackEvent.install", channel: "Facebook", user: "user_b_8842", refCode: "ref_a9f3ce2b8d", configID: "cfg_pkg_001", cardID: "card_pkg_001", landingID: "lp_001_new", color: "green", status: "✓" },
      { ev: "share()", channel: "Discord", user: "user_c_9921", refCode: "ref_d3a8b2c1f9", configID: "cfg_plan_001", cardID: "card_plan_001", landingID: "lp_001_return", color: "brand", status: "✓" },
      { ev: "fetchConfig()", channel: "—", refCode: "package:p_a1b2c3d4e5f6 → cfg_pkg_001", configID: "cfg_pkg_001", cardID: "—", landingID: "—", color: "amber", status: "✓" },
      { ev: "handleDeepLink()", channel: "WhatsApp", refCode: "ref_e7f4a1b2c3", configID: "cfg_plan_001", cardID: "card_pkg_001", landingID: "lp_001_new", color: "rose", status: "✗ DEEP_LINK_FAILED" },
      { ev: "trackEvent.purchase", channel: "Discord", user: "user_e_2210", refCode: "ref_g1h2i3j4k5", configID: "cfg_plan_001", cardID: "card_plan_001", landingID: "lp_001_return", amount: 9.99, color: "rose", status: "✓" },
    ];
    const colors = {
      brand: "border-brand-500 bg-brand-50",
      blue:  "border-cyan-500 bg-cyan-50",
      green: "border-emerald-500 bg-emerald-50",
      amber: "border-amber-500 bg-amber-50",
      rose:  "border-rose-500 bg-rose-50",
    };
    const tick = () => {
      const e = events[counter % events.length];
      counter++;
      const t = new Date().toLocaleTimeString("zh-CN", { hour12: false });
      const isErr = e.status.startsWith("✗");
      const html = `
        <div class="border-l-4 ${colors[e.color]} pl-3 pr-2 py-2 rounded-r-lg text-xs animate-fade-up">
          <div class="flex items-center gap-2">
            <span class="text-ink-400 font-mono num">${t}</span>
            <span class="font-bold text-ink-900 font-mono">${e.ev}</span>
            <span class="text-ink-400">→</span>
            <span>${e.channel}</span>
            <span class="ml-auto text-[10px] ${isErr ? "text-rose-600 font-bold" : "text-emerald-600"} font-semibold">${e.status}</span>
            ${e.amount ? `<span class="font-bold text-emerald-600 num">+ $${e.amount}</span>` : ""}
          </div>
          <div class="text-[10px] text-ink-400 font-mono mt-0.5">${e.refCode}</div>
          <div class="mt-1 flex flex-wrap gap-1 text-[10px] font-mono">
            <span class="px-1.5 py-0.5 rounded bg-white/70 text-ink-700">ConfigID: ${e.configID}</span>
            <span class="px-1.5 py-0.5 rounded bg-white/70 text-blue-700">CardID: ${e.cardID}</span>
            <span class="px-1.5 py-0.5 rounded bg-white/70 text-brand-700">LandingPageID: ${e.landingID}</span>
          </div>
        </div>
      `;
      stream.insertAdjacentHTML("afterbegin", html);
      while (stream.children.length > 12) stream.lastChild.remove();
    };
    tick();
    Pages.__streamTimer && clearInterval(Pages.__streamTimer);
    Pages.__streamTimer = setInterval(tick, 1500);
  };

  return `
    ${UI.pageHeader({
      title: "SDK 监控",
      desc: "查看接入 SDK 的运行状态、接口性能、错误日志、调试工具",
      icon: "📡",
      actions: UI.primaryBtn("🧪 模拟分享", { onclick: "UI.toast('已发起一次模拟分享', 'success')" }),
    })}

    <!-- 概览 -->
    <div class="grid grid-cols-5 gap-4 mb-4">
      ${UI.statCard({ label: "接入游戏", value: m.summary.games, delta: 0, icon: "🎮", color: "brand" })}
      ${UI.statCard({ label: "接入包体", value: m.summary.packages, delta: 0, icon: "📦", color: "blue" })}
      ${UI.statCard({ label: "活跃 SDK", value: m.summary.sdk_active, delta: 0, icon: "📡", color: "green" })}
      ${UI.statCard({ label: "今日活跃", value: m.summary.sdk_active_today, delta: 5, icon: "✅", color: "amber" })}
      ${UI.statCard({ label: "错误率 24h", value: m.summary.error_rate + "%", delta: -8, icon: "⚠️", color: "rose" })}
    </div>

    <!-- 调用趋势 + 版本分布 -->
    <div class="grid grid-cols-3 gap-4 mb-4">
      <div class="col-span-2 card p-6">
        <h3 class="text-sm font-bold text-ink-900 mb-3">SDK 接口调用量趋势 · 14 天</h3>
        <div id="sdk-call-trend" style="height: 280px;"></div>
      </div>
      <div class="card p-6">
        <h3 class="text-sm font-bold text-ink-900 mb-4">版本分布</h3>
        <div class="space-y-3">
          ${m.version_dist.map((v, i) => {
            const colors = ["bg-brand-900", "bg-brand-700", "bg-brand-500", "bg-warn-600", "bg-danger-600", "bg-ink-400"];
            return `
              <div>
                <div class="flex items-center justify-between text-xs mb-1.5">
                  <span class="font-medium"><span class="font-mono text-ink-900">${v.version}</span> <span class="text-ink-400">/ ${v.platform}</span></span>
                  <span class="num font-semibold text-ink-900">${v.count} <span class="text-ink-400 font-normal">(${v.percent}%)</span></span>
                </div>
                <div class="h-1.5 bg-ink-100 rounded-full overflow-hidden">
                  <div class="h-full ${colors[i] || colors[0]} rounded-full" style="width:${v.percent}%"></div>
                </div>
              </div>`;
          }).join("")}
        </div>
      </div>
    </div>

    <!-- 接口性能 -->
    <div class="card mb-4 overflow-hidden">
      <div class="px-6 py-4 border-b border-ink-100 flex items-center justify-between">
        <h3 class="text-sm font-bold text-ink-900">接口性能 · 最近 24 小时</h3>
        <span class="text-[10px] text-ink-400">每 5 分钟聚合</span>
      </div>
      <table class="w-full text-sm">
        <thead class="bg-ink-50 text-xs text-ink-500">
          <tr>
            <th class="text-left px-6 py-3 font-semibold">API 接口</th>
            <th class="text-right px-4 py-3 font-semibold">调用次数</th>
            <th class="text-right px-4 py-3 font-semibold">错误率</th>
            <th class="text-right px-4 py-3 font-semibold">P95 延迟</th>
            <th class="text-left px-4 py-3 font-semibold">状态</th>
            <th class="text-right px-6 py-3 font-semibold">操作</th>
          </tr>
        </thead>
        <tbody>
          ${m.api_calls.map(a => `
            <tr class="border-t border-ink-100 row-hover">
              <td class="px-6 py-3"><code class="font-mono text-xs px-2 py-1 bg-ink-50 rounded">${a.api}</code></td>
              <td class="px-4 py-3 text-right num font-semibold">${UI.fmtNum(a.calls)}</td>
              <td class="px-4 py-3 text-right">
                <span class="num font-bold ${a.error_rate > 3 ? "text-rose-600" : a.error_rate > 1 ? "text-amber-600" : "text-ink-700"}">${a.error_rate.toFixed(2)}%</span>
              </td>
              <td class="px-4 py-3 text-right num">${a.p95} ms</td>
              <td class="px-4 py-3">
                ${a.status === "normal" ? '<span class="badge bg-emerald-50 text-emerald-700"><span class="w-1.5 h-1.5 rounded-full bg-emerald-500"></span>正常</span>' : '<span class="badge bg-amber-50 text-amber-700"><span class="w-1.5 h-1.5 rounded-full bg-amber-500 animate-pulse-soft"></span>告警</span>'}
              </td>
              <td class="px-6 py-3 text-right">
                <button class="text-xs text-brand-700 hover:underline font-medium">详情</button>
              </td>
            </tr>`).join("")}
        </tbody>
      </table>
    </div>

    <!-- 错误日志 + 事件流 -->
    <div class="grid grid-cols-2 gap-4">
      <div class="card p-6">
        <div class="flex items-center justify-between mb-3">
          <h3 class="text-sm font-bold text-ink-900 flex items-center gap-2">⚠️ 错误日志（Top 4）</h3>
          <button class="text-xs text-brand-700 hover:underline font-medium">查看全部 →</button>
        </div>
        <div class="space-y-2">
          ${m.errors.map(e => `
            <div class="border border-ink-100 rounded-xl p-3 hover:border-rose-300 hover:bg-rose-50/30 transition">
              <div class="flex items-center gap-2 text-xs flex-wrap">
                <code class="px-2 py-0.5 bg-rose-50 text-rose-700 rounded text-[10px] font-mono font-semibold">${e.code}</code>
                <span class="badge bg-ink-100 text-ink-700">${e.platform}</span>
                <span class="badge bg-cyan-50 text-cyan-700">${e.sdk}</span>
                <span class="ml-auto text-ink-400 num">${e.time}</span>
              </div>
              <div class="text-xs text-ink-700 mt-2">${e.sample}</div>
              <div class="flex items-center justify-between mt-2">
                <span class="text-[11px] text-ink-500">影响 <strong class="text-rose-600 num">${e.count}</strong> 次调用</span>
                <button class="text-[11px] text-brand-700 hover:underline font-medium">查看堆栈 →</button>
              </div>
            </div>
          `).join("")}
        </div>
      </div>

      <div class="card p-6">
        <div class="flex items-center justify-between mb-3">
          <h3 class="text-sm font-bold text-ink-900 flex items-center gap-2">
            <span class="w-2 h-2 rounded-full bg-emerald-500 animate-pulse-soft"></span>
            实时事件流
          </h3>
          <div class="flex items-center gap-2 text-xs">
            <select class="border border-ink-200 rounded-md px-2 py-1">
              <option>所有接口</option><option>share()</option><option>trackEvent()</option>
            </select>
            <button class="px-2 py-1 text-ink-500 hover:bg-ink-50 rounded">⏸</button>
          </div>
        </div>
        <div id="event-stream" class="space-y-1.5 max-h-96 overflow-y-auto"></div>
      </div>
    </div>

    <!-- 调试工具（折叠） -->
    <details class="card mt-4">
      <summary class="px-6 py-4 cursor-pointer flex items-center gap-2">
        <svg class="chev w-3 h-3 text-ink-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/></svg>
        <span class="text-sm font-bold">🔧 调试工具：模拟分享 + 平台缓存刷新</span>
      </summary>
      <div class="px-6 pb-6 grid grid-cols-2 gap-6 border-t border-ink-100 pt-5">
        <div>
          <label class="text-xs text-ink-500">选择游戏 / 包体</label>
          <select class="w-full mt-1 px-3 py-2 border border-ink-200 rounded-xl text-sm bg-white">
            ${MOCK.PACKAGES.map(p => {
              const g = MOCK.GAMES.find(x => x.id === p.game_id);
              return `<option>${g?.icon} ${g?.name} / ${p.name} · RippleID ${p.id}</option>`;
            }).join("")}
          </select>
          <div class="grid grid-cols-2 gap-3 mt-3">
            <div>
              <label class="text-xs text-ink-500">ConfigID</label>
              <select class="w-full mt-1 px-3 py-2 border border-ink-200 rounded-xl text-sm bg-white font-mono">
                ${MOCK.SHARE_CONFIGS.map(cfg => `<option>${cfg.config_id || cfg.id}</option>`).join("")}
              </select>
            </div>
            <div>
              <label class="text-xs text-ink-500">CardID</label>
              <select class="w-full mt-1 px-3 py-2 border border-ink-200 rounded-xl text-sm bg-white font-mono">
                ${MOCK.SHARE_CONFIGS.map(cfg => `<option>card_${(cfg.config_id || cfg.id).replace(/^cfg_/, "")}</option>`).join("")}
              </select>
            </div>
          </div>
          <div class="mt-3 rounded-xl border border-brand-100 bg-brand-50 p-3 text-xs text-brand-900">
            <div class="font-semibold">预期组合选择</div>
            <div class="mt-1 font-mono">cfg_pkg_001 → card_pkg_001 + lp_001_new</div>
            <div class="mt-1 text-brand-700">客户端只传 ConfigID，SDK 读取对应 CardID + LandingPageID 组合。</div>
          </div>
          <label class="text-xs text-ink-500 mt-3 block">选择渠道</label>
          <div class="grid grid-cols-4 gap-2 mt-1.5">
            ${MOCK.CHANNELS.filter(c => c.enabled).slice(0, 8).map((c, i) => `
              <button class="px-2 py-2 border ${i === 0 ? "border-brand-500 bg-brand-50" : "border-ink-200 hover:border-brand-300"} rounded-lg text-xs flex flex-col items-center transition">
                <span class="text-base">${c.icon}</span>
                <span class="mt-0.5 text-[10px] ${i === 0 ? "text-brand-700 font-semibold" : ""}">${c.name}</span>
              </button>
            `).join("")}
          </div>
          ${UI.primaryBtn("🚀 模拟分享", { onclick: "UI.toast('已按 ConfigID 模拟分享，并读取 Card + Landing 组合', 'success')" })}
        </div>
        <div>
          <div class="text-xs font-semibold text-ink-700 mb-2">Crawler 缓存刷新</div>
          <div class="space-y-2">
            ${[
              { name: "Facebook Sharing Debugger", icon: "📘", api: "官方 API 立即刷新" },
              { name: "Twitter Card Validator", icon: "𝕏", api: "validator URL 触发" },
              { name: "WhatsApp", icon: "📱", api: "无官方 API · 落地页带 ?v=", warn: true },
              { name: "Telegram", icon: "✈️", api: "instant view 测试刷新" },
            ].map(s => `
              <div class="flex items-center gap-2 p-2.5 rounded-xl ${s.warn ? "border border-amber-200 bg-amber-50/30" : "hover:bg-ink-50"}">
                <span class="text-base">${s.icon}</span>
                <div class="flex-1 min-w-0">
                  <div class="text-xs font-medium text-ink-900">${s.name}</div>
                  <div class="text-[10px] text-ink-500">${s.api}</div>
                </div>
                <button onclick="UI.toast('已发起 ${s.name} 缓存刷新', 'info')" class="px-2.5 py-1 text-[11px] ${s.warn ? "bg-amber-100 text-amber-700" : "bg-brand-50 text-brand-700"} rounded-md font-medium">刷新</button>
              </div>
            `).join("")}
          </div>
        </div>
      </div>
    </details>
  `;
};

// __window_exports__
// Expose helpers for cross-page / inline onclick compatibility
